import React from 'react';
import PropTypes from 'prop-types';

import { formatCurrency } from 'utils/currency';
import styles from './NonSubscribableDetails.module.scss';

const NonSubscribableDetails = ({ retailPrice }) => (
  <p className={styles.regularPrice}>
    {`Regular Price: ${formatCurrency(retailPrice)}`}
    <i
      className="fas fa-info-circle"
      data-tip="The price shown represents the product's estimated original retail price."
      data-testid="info-icon"
    />
  </p>
);

NonSubscribableDetails.propTypes = {
  retailPrice: PropTypes.string.isRequired,
};

export default NonSubscribableDetails;
